(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 8312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(5832);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2448:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Seo; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);


function toRobotsContent(robots) {
    if (!robots) return undefined;
    var _index;
    const index = (_index = robots.index) !== null && _index !== void 0 ? _index : true;
    var _follow;
    const follow = (_follow = robots.follow) !== null && _follow !== void 0 ? _follow : true;
    return "".concat(index ? "index" : "noindex", ", ").concat(follow ? "follow" : "nofollow");
}
function Seo(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12;
    const description = (ref = props.description) === null || ref === void 0 ? void 0 : ref.trim();
    const canonicalUrl = (ref1 = props.canonicalUrl) === null || ref1 === void 0 ? void 0 : ref1.trim();
    var ref13;
    const ogTitle = (ref13 = (ref2 = props.openGraph) === null || ref2 === void 0 ? void 0 : ref2.title) !== null && ref13 !== void 0 ? ref13 : props.title;
    var ref14;
    const ogDescription = (ref14 = (ref3 = props.openGraph) === null || ref3 === void 0 ? void 0 : ref3.description) !== null && ref14 !== void 0 ? ref14 : description;
    var ref15;
    const ogType = (ref15 = (ref4 = props.openGraph) === null || ref4 === void 0 ? void 0 : ref4.type) !== null && ref15 !== void 0 ? ref15 : "website";
    var ref16;
    const ogUrl = (ref16 = (ref5 = props.openGraph) === null || ref5 === void 0 ? void 0 : ref5.url) !== null && ref16 !== void 0 ? ref16 : canonicalUrl;
    var ref17;
    const twCard = (ref17 = (ref6 = props.twitter) === null || ref6 === void 0 ? void 0 : ref6.card) !== null && ref17 !== void 0 ? ref17 : "summary_large_image";
    var ref18;
    const twTitle = (ref18 = (ref7 = props.twitter) === null || ref7 === void 0 ? void 0 : ref7.title) !== null && ref18 !== void 0 ? ref18 : props.title;
    var ref19;
    const twDescription = (ref19 = (ref8 = props.twitter) === null || ref8 === void 0 ? void 0 : ref8.description) !== null && ref19 !== void 0 ? ref19 : description;
    var ref20;
    const twUrl = (ref20 = (ref9 = props.twitter) === null || ref9 === void 0 ? void 0 : ref9.url) !== null && ref20 !== void 0 ? ref20 : canonicalUrl;
    const robotsContent = toRobotsContent(props.robots);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: props.title
            }, "title"),
            description ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }, "description") : null,
            props.keywords ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: props.keywords
            }, "keywords") : null,
            canonicalUrl ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: canonicalUrl
            }, "canonical") : null,
            robotsContent ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: robotsContent
            }, "robots") : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: ogTitle
            }, "og:title"),
            ogDescription ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: ogDescription
            }, "og:description") : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: ogType
            }, "og:type"),
            ((ref10 = props.openGraph) === null || ref10 === void 0 ? void 0 : ref10.image) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: props.openGraph.image
                    }, "og:image"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image:secure_url",
                        content: props.openGraph.image
                    }, "og:image:secure_url")
                ]
            }) : null,
            ogUrl ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: ogUrl
            }, "og:url") : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: twCard
            }, "twitter:card"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: twTitle
            }, "twitter:title"),
            twDescription ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: twDescription
            }, "twitter:description") : null,
            ((ref11 = props.twitter) === null || ref11 === void 0 ? void 0 : ref11.image) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: props.twitter.image
            }, "twitter:image") : null,
            twUrl ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:url",
                content: twUrl
            }, "twitter:url") : null,
            (ref12 = props.jsonLd) === null || ref12 === void 0 ? void 0 : ref12.map((block, idx)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    type: "application/ld+json",
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify(block)
                    }
                }, "jsonld-".concat(idx))),
            props.children
        ]
    });
}


/***/ }),

/***/ 5832:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./components/AppNavBar.tsx + 1 modules
var AppNavBar = __webpack_require__(7486);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(6886);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(5861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 3 modules
var Button = __webpack_require__(9417);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./utils/Constants.ts
var Constants = __webpack_require__(953);
// EXTERNAL MODULE: ./utils/ImageExport.ts + 6 modules
var ImageExport = __webpack_require__(645);
// EXTERNAL MODULE: ./node_modules/@mui/material/Rating/Rating.js + 4 modules
var Rating = __webpack_require__(961);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 2 modules
var Box = __webpack_require__(4253);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Star.js
var Star = __webpack_require__(4957);
;// CONCATENATED MODULE: ./components/AppStarRating.tsx





function AppStarRating(param) {
    let { Rate  } = param;
    const displayValue = Math.min(5, Rate + 0.1);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        sx: {
            display: "flex",
            alignItems: "center",
            textAlign: "center",
            zIndex: 10,
            justifyContent: {
                xs: "center",
                md: "left"
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Rating/* default */.Z, {
            name: "read-only",
            value: displayValue,
            precision: 0.1,
            readOnly: true,
            emptyIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Star/* default */.Z, {
                style: {
                    color: "white"
                },
                fontSize: "inherit"
            })
        })
    });
}

;// CONCATENATED MODULE: ./components/home/1-landing/Landing.tsx









function Landing(param) {
    let { imgSrc  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                    rel: "preload",
                    href: ImageExport/* PLAYSTORE_BLACK.src */.ZE.src,
                    as: "image"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                sx: {
                    display: {
                        xs: "block",
                        md: "flex"
                    },
                    justifyContent: "center",
                    alignItems: "center",
                    minHeight: {
                        xs: "90vh",
                        md: "95vh",
                        lg: "60vh"
                    }
                },
                style: {
                    width: "100%",
                    background: "linear-gradient(60.24deg, #08AC17 -21.65%, #4D71D0 93.65%)",
                    position: "relative"
                },
                className: "Landing_WrapperGrid",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                        sx: {
                            maxWidth: "1440px",
                            display: {
                                xs: "block",
                                md: "flex"
                            },
                            justifyContent: "center",
                            alignItems: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                sx: {
                                    display: {
                                        xs: "block",
                                        md: "flex"
                                    },
                                    width: {
                                        xs: "100%",
                                        md: "45%"
                                    },
                                    paddingTop: {
                                        xs: "22px",
                                        md: "0"
                                    },
                                    height: {
                                        xs: "100%",
                                        md: "80%",
                                        xl: "100%"
                                    },
                                    justifyContent: "right",
                                    alignItems: "center"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                    sx: {
                                        width: {
                                            xs: "100%",
                                            md: "100%"
                                        },
                                        height: {
                                            xs: "100%",
                                            md: "100%"
                                        },
                                        padding: {
                                            xs: "12% 10% 1% 10%",
                                            md: "1% 8%"
                                        }
                                    },
                                    style: {
                                        color: "white",
                                        lineHeight: "56px",
                                        letterSpacing: "-1%",
                                        zIndex: 1
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                            fontWeight: "800",
                                            component: "h1",
                                            sx: {
                                                fontSize: {
                                                    xs: "26px",
                                                    sm: "32px",
                                                    md: "48px",
                                                    lg: "56px"
                                                },
                                                margin: 0,
                                                lineHeight: {
                                                    xs: "34px",
                                                    sm: "40px",
                                                    md: "60px",
                                                    lg: "72px"
                                                },
                                                letterSpacing: {
                                                    xs: "-0.2px",
                                                    md: "-0.6px"
                                                },
                                                paddingBottom: {
                                                    xs: "18px",
                                                    md: "40px"
                                                }
                                            },
                                            children: [
                                                "India's #1 Platform for Earning by Selling Financial Products",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    component: "span",
                                                    fontWeight: "600",
                                                    sx: {
                                                        display: "block",
                                                        marginTop: {
                                                            xs: "10px",
                                                            md: "12px"
                                                        },
                                                        fontSize: {
                                                            xs: "14px",
                                                            sm: "18px",
                                                            md: "22px"
                                                        },
                                                        lineHeight: {
                                                            xs: "20px",
                                                            md: "28px"
                                                        },
                                                        opacity: 0.95
                                                    },
                                                    children: "Zero Investment, Instant Payouts"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                            sx: {
                                                display: "flex"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                                width: "fit-content",
                                                sx: {
                                                    display: {
                                                        xs: "none",
                                                        md: "block"
                                                    },
                                                    marginRight: "32px"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: Constants/* appLink */.ze,
                                                        rel: "preload",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                            src: ImageExport/* PLAYSTORE_BLACK */.ZE,
                                                            alt: "playstore",
                                                            width: 120,
                                                            height: 64,
                                                            priority: true
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                                        sx: {
                                                            display: "flex",
                                                            alignItems: "center"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AppStarRating, {
                                                                Rate: 4.3
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                variant: "body2",
                                                                style: {
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    cursor: "default",
                                                                    marginLeft: "4px",
                                                                    marginTop: "5px"
                                                                },
                                                                children: "4.3"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        variant: "body2",
                                                        style: {
                                                            display: "flex",
                                                            alignItems: "center",
                                                            cursor: "default",
                                                            marginTop: "5px"
                                                        },
                                                        children: "68K+ Reviews"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                sx: {
                                    margin: {
                                        xs: "auto",
                                        md: "0"
                                    },
                                    justifyContent: {
                                        xs: "center",
                                        md: "none"
                                    },
                                    paddingTop: {
                                        xs: "0px",
                                        md: "72px"
                                    },
                                    height: {
                                        xs: "100%",
                                        md: "70%"
                                    },
                                    width: {
                                        xs: "100%",
                                        md: "45%"
                                    },
                                    display: "flex",
                                    alignItems: "end",
                                    position: "relative",
                                    paddingBottom: {
                                        xs: "0px",
                                        md: "0"
                                    },
                                    overflow: {
                                        xs: "hidden",
                                        md: "visible"
                                    }
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                        sx: {
                                            margin: "60px 0",
                                            width: "250px",
                                            height: "500px"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: "https://cdn.gromo.in/static-resources/notification-resources/notification_images/1747204363_phone.webp",
                                                alt: "GroMo app showing earnings dashboard on mobile",
                                                width: 250,
                                                height: 500,
                                                layout: "intrinsic",
                                                priority: true
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                onClick: ()=>{
                                                    window.location.href = Constants/* appLink */.ze;
                                                },
                                                sx: {
                                                    display: [
                                                        "flex",
                                                        "flex",
                                                        "none"
                                                    ],
                                                    cursor: "pointer"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: ImageExport/* PLAYSTORE_BLACK */.ZE,
                                                    alt: "play-store",
                                                    width: 120,
                                                    height: 48,
                                                    style: {
                                                        width: "auto",
                                                        zIndex: "100",
                                                        height: "48px",
                                                        objectFit: "contain",
                                                        alignItems: "center",
                                                        marginLeft: "35px",
                                                        marginTop: "10px"
                                                    }
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                        sx: {
                                            height: {
                                                xs: "150px",
                                                md: "309px"
                                            },
                                            width: {
                                                xs: "200%",
                                                md: "100%"
                                            },
                                            zIndex: 0,
                                            position: "absolute",
                                            left: {
                                                xs: "-200px",
                                                md: "0"
                                            },
                                            bottom: {
                                                xs: "0px",
                                                md: "-80px"
                                            },
                                            right: {
                                                xs: "-200px",
                                                md: "0"
                                            },
                                            margin: "auto",
                                            display: {
                                                xs: "none",
                                                md: "block"
                                            }
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                            width: "100%",
                                            height: "100%",
                                            viewBox: "0 0 797 314",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                                opacity: "0.1",
                                                cx: "398.5",
                                                cy: "398.5",
                                                r: "328.5",
                                                stroke: "white",
                                                strokeWidth: "140"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                        sx: {
                                            display: {
                                                xs: "block",
                                                md: "none"
                                            },
                                            position: "absolute",
                                            bottom: "-500px",
                                            left: "50%",
                                            marginLeft: "-330px"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                            width: "660",
                                            height: "712",
                                            viewBox: "0 0 360 612",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                                opacity: "0.1",
                                                cx: "175.5",
                                                cy: "308.5",
                                                r: "273.5",
                                                stroke: "white",
                                                strokeWidth: "70"
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                        sx: {
                            display: {
                                xs: "block",
                                md: "none"
                            },
                            justifyContent: "center",
                            width: "100%",
                            textAlign: "center",
                            paddingBottom: "32px",
                            height: ""
                        },
                        children: [
                            imgSrc ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                rel: "preload",
                                href: Constants/* appLink */.ze,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: imgSrc,
                                    alt: "",
                                    width: 120,
                                    height: 48,
                                    style: {
                                        width: "auto",
                                        height: "48px",
                                        objectFit: "contain"
                                    },
                                    loading: "lazy"
                                })
                            }) : null,
                            imgSrc === ImageExport/* PLAYSTORE_BLACK */.ZE ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                width: "100%",
                                textAlign: "center",
                                sx: {
                                    display: "grid",
                                    placeContent: "center"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AppStarRating, {
                                        Rate: 4.3
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                        variant: "body2",
                                        style: {
                                            display: "flex",
                                            alignItems: "center",
                                            cursor: "default",
                                            marginTop: "5px",
                                            color: "white"
                                        },
                                        children: [
                                            "4.3",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                style: {
                                                    opacity: "0.5",
                                                    margin: "0px 8px",
                                                    fontSize: "20px"
                                                },
                                                children: "•"
                                            }),
                                            "68K+ Reviews"
                                        ]
                                    })
                                ]
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        sx: {
                            height: {
                                xs: "100px",
                                md: "289px"
                            },
                            width: {
                                xs: "250px",
                                md: "500px"
                            }
                        },
                        style: {
                            position: "absolute",
                            top: "0",
                            left: "0"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                            width: "100%",
                            height: "434",
                            viewBox: "0 0 389 434",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                opacity: "0.1",
                                cx: "47.5",
                                cy: "92.5",
                                r: "281.5",
                                stroke: "white",
                                strokeWidth: "120"
                            })
                        })
                    })
                ]
            })
        ]
    });
}
const getServerSideProps = async ()=>{
    const imgSrc = PLAYSTORE_BLACK;
    return {
        props: {
            imgSrc
        }
    };
};
/* harmony default export */ var _1_landing_Landing = (Landing);

// EXTERNAL MODULE: ./components/Seo.tsx
var Seo = __webpack_require__(2448);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./pages/index.tsx





// Dynamic Imports

const Stats = dynamic_default()(()=>__webpack_require__.e(/* import() */ 9099).then(__webpack_require__.bind(__webpack_require__, 9099)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(9099)
            ]
    }
});
const TheProcess = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(296), __webpack_require__.e(1529), __webpack_require__.e(9464), __webpack_require__.e(4485), __webpack_require__.e(7451)]).then(__webpack_require__.bind(__webpack_require__, 2910)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(2910)
            ]
    }
});
const Investors = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(1033), __webpack_require__.e(4938), __webpack_require__.e(4485), __webpack_require__.e(7572)]).then(__webpack_require__.bind(__webpack_require__, 1747)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(1747)
            ]
    }
});
const Features = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(1529), __webpack_require__.e(4485), __webpack_require__.e(4143)]).then(__webpack_require__.bind(__webpack_require__, 8839)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(8839)
            ]
    }
});
const FeatureScroll = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(1033), __webpack_require__.e(4485), __webpack_require__.e(9181)]).then(__webpack_require__.bind(__webpack_require__, 9181)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(9181)
            ]
    }
});
const OurProducts = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(4485), __webpack_require__.e(6191)]).then(__webpack_require__.bind(__webpack_require__, 6191)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(6191)
            ]
    }
});
const Brand = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(1033), __webpack_require__.e(4938), __webpack_require__.e(2631)]).then(__webpack_require__.bind(__webpack_require__, 9584)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(9584)
            ]
    }
});
const Testimonials = dynamic_default()(()=>__webpack_require__.e(/* import() */ 9054).then(__webpack_require__.bind(__webpack_require__, 9054)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(9054)
            ]
    }
});
const Blogs = dynamic_default()(()=>__webpack_require__.e(/* import() */ 6978).then(__webpack_require__.bind(__webpack_require__, 6978)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(6978)
            ]
    }
});
const Press = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(1033), __webpack_require__.e(4938), __webpack_require__.e(4485), __webpack_require__.e(1420)]).then(__webpack_require__.bind(__webpack_require__, 4241)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(4241)
            ]
    }
});
const AppFooter = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(5045), __webpack_require__.e(9705)]).then(__webpack_require__.bind(__webpack_require__, 9705)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(9705)
            ]
    }
});
const ApplicationCTA = dynamic_default()(()=>__webpack_require__.e(/* import() */ 9002).then(__webpack_require__.bind(__webpack_require__, 9072)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(9072)
            ]
    }
});
const ElevenLabsBadge = dynamic_default()(()=>__webpack_require__.e(/* import() */ 4257).then(__webpack_require__.bind(__webpack_require__, 4257)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(4257)
            ]
    }
});
const Home = (param)=>{
    let { initialNavColor  } = param;
    const [navColor, setNavColor] = (0,react.useState)(initialNavColor);
    (0,react.useEffect)(()=>{
        const handleScroll = ()=>{
            if (window.scrollY > 100) {
                setNavColor("#002561");
            } else {
                setNavColor("transparent");
            }
        };
        window.addEventListener("scroll", handleScroll, {
            passive: true
        });
        handleScroll(); // Set the initial color based on the current scroll position
        return ()=>{
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Seo/* default */.Z, {
                title: "GroMo: Sell Financial Products & Earn 1 Lakh/Month | Zero Investment",
                description: "Gromo is India's best real money earning app to earn extra income online without investment. Become a Gromo partner to Sell financial products & earn real money.",
                keywords: "GroMo Money Making Application, पैसे कमाने वाला ऐप, बिना निवेश कमाई, घर बैठे कमाई, ऑनलाइन पैसे कमाए",
                openGraph: {
                    title: "GroMo — Sell Financial Products & Earn ₹1 Lakh/Month | 60L+ Partners | Shark Tank India' Description: 'India’s largest financial product distribution platform. 60L+ partners. Sell credit cards, loans, savings accounts. Zero investment. Instant payouts. Y Combinator backed.",
                    description: "Gromo is India's best real money earning app to earn extra income online without investment. Become a Gromo partner to Sell financial products & earn real money.",
                    type: "website",
                    image: "https://elasticbeanstalk-ap-south-1-812175807951.s3.ap-south-1.amazonaws.com/static-resources/notification-resources/notification_images/1668084562_Meta+Image-low+size.webp"
                },
                twitter: {
                    title: "Become A Certified Financial Advisor, Earn Money up to ₹1 Lakh",
                    description: "Become a partner and make a regular income by selling financial products. Brand yourself as a certified financial advisor and launch and grow your business.",
                    url: "https://gromo.in",
                    image: "https://elasticbeanstalk-ap-south-1-812175807951.s3.ap-south-1.amazonaws.com/static-resources/notification-resources/notification_images/1668084562_Meta+Image-low+size.webp"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    name: "facebook-domain-verification",
                    content: "h5cwilbbvtk9ui5zbw1dn1i47ohmj1"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AppNavBar/* default */.Z, {
                navBgColor: navColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(_1_landing_Landing, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stats, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TheProcess, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Investors, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Features, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureScroll, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OurProducts, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Brand, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Testimonials, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Press, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Blogs, {
                heading: "GroMo Blogs"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ApplicationCTA, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ElevenLabsBadge, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AppFooter, {})
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var pages = (Home);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3581,6886,6499,5675,7538,7856,7486,9774,2888,179], function() { return __webpack_exec__(8312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);